import { render, staticRenderFns } from "./MultiPatientSelector.vue?vue&type=template&id=657dc3eb&"
import script from "./MultiPatientSelector.vue?vue&type=script&lang=ts&"
export * from "./MultiPatientSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports